import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
export function AngelikaSturnCoachingPage() {
  return <div className="min-h-screen bg-white" data-id="element-287">
      <Header data-id="element-288" />
      {/* Hero Section mit Bild und Zitat */}
      <section className="w-full mt-[152px] flex justify-center" data-id="element-289">
        <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-290">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7LSsWDbN33SAJKwVMZjs9p/Header-Coaching-Angelika_Sturny.jpg" alt="Coaching Header Bild" className="w-full h-full object-cover" data-id="element-291" />
          <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-292"></div>
          <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-293">
            <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-294">
              <div className="max-w-lg text-left" data-id="element-295">
                <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-296">
                  "Unsere größte Freiheit ist die Freiheit, unsere Einstellung
                  zu wählen."
                </blockquote>
                <p className="text-white text-xl" data-id="element-297">– Viktor Frankl</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="w-full py-16 px-6 md:px-12" data-id="element-298">
        <div className="max-w-4xl mx-auto" data-id="element-299">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-4" data-id="element-300">
            Coaching
          </h1>
          <h2 className="text-xl md:text-2xl font-light text-gray-600 mb-8" data-id="element-301">
            Innehalten. Reflektieren. Klarheit finden. Neue Wege wagen.
          </h2>
          <div className="prose prose-lg max-w-none" data-id="element-302">
            <div className="mb-12" data-id="element-303">
              <p className="text-lg text-gray-700 mb-6" data-id="element-304">
                Manchmal braucht es einen geschützten Raum, um innezuhalten,
                sich neu zu sortieren und den eigenen Weg wieder klarer zu
                sehen. Coaching bietet genau diesen Raum – für Reflexion,
                Entwicklung und Entscheidung. Ob es um berufliche
                Herausforderungen, persönliche Übergänge oder das Bedürfnis nach
                mehr Sinn und Selbstwirksamkeit geht – Coaching ist ein
                gemeinsamer Prozess, der Sie stärkt und in Bewegung bringt.
              </p>
              <p className="text-lg text-gray-700" data-id="element-305">
                Ich begleite Führungskräfte, Projektverantwortliche und Menschen
                in Übergangsphasen dabei, ihre Themen mit Abstand zu betrachten,
                innere und äußere Dynamiken zu verstehen und stimmige
                Entscheidungen zu treffen.
              </p>
            </div>
            <div className="bg-pink-50 p-8 rounded-lg mb-12" data-id="element-306">
              <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-307">
                Führung bedeutet oft, Entscheidungen unter Unsicherheit zu
                treffen, Spannungsfelder zu navigieren und dabei sich selbst
                nicht aus dem Blick zu verlieren.
              </p>
              <p className="text-lg text-gray-700" data-id="element-308">
                Im Coaching geht es um Reflektion und die Möglichkeit, neue
                Blickwinkel und Perspektiven zu gewinnen. Dabei sind Ihre
                Erfahrungen, Werte und Ressourcen der Ausgangspunkt. Mit
                systemischem Blick, psychologischem Fachwissen und viel Gespür
                für das, was zwischen den Zeilen wirkt, unterstütze ich Sie
                dabei, Klarheit zu gewinnen, stimmige Entscheidungen zu treffen
                und neue Handlungsspielräume zu entdecken.
              </p>
            </div>
            <div className="mb-12" data-id="element-309">
              <h2 className="text-2xl font-light text-gray-700 mb-6" data-id="element-310">
                Themen für ein Coaching können zum Beispiel sein:
              </h2>
              <ul className="space-y-6 text-gray-700" data-id="element-311">
                <li className="flex items-start" data-id="element-312">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-313"></div>
                  <div data-id="element-314">
                    <span className="font-medium" data-id="element-315">
                      Neuorientierung in beruflichen und privaten Umbruchphasen:
                    </span>{' '}
                    Veränderungen kommen oft ungeplant – sei es durch
                    Jobwechsel, neue Lebenssituationen oder innere
                    Veränderungsimpulse. Im Coaching schaffen wir einen klaren
                    Rahmen, um Gedanken zu sortieren, Prioritäten
                    herauszuarbeiten und tragfähige Entscheidungen zu treffen.
                    So entsteht Klarheit über den nächsten Schritt.
                  </div>
                </li>
                <li className="flex items-start" data-id="element-316">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-317"></div>
                  <div data-id="element-318">
                    <span className="font-medium" data-id="element-319">
                      Führung und Rollenklärung:
                    </span>{' '}
                    Bei Übernahme einer Führungsrolle, im Übergang vom
                    Kollegen/Kollegin zum/zur Vorgesetzten oder bei Themen der
                    Positionierung in Ihrer jetzigen Rolle.
                  </div>
                </li>
                <li className="flex items-start" data-id="element-320">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-321"></div>
                  <div data-id="element-322">
                    <span className="font-medium" data-id="element-323">
                      Karriereentwicklung und persönliche Standortbestimmung:
                    </span>{' '}
                    Sie stehen an einem Wendepunkt und möchten Ihre nächsten
                    Schritte bewusst und kraftvoll gestalten.
                  </div>
                </li>
                <li className="flex items-start" data-id="element-324">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-325"></div>
                  <div data-id="element-326">
                    <span className="font-medium" data-id="element-327">
                      Umgang mit Komplexität und Entscheidungsdruck:
                    </span>{' '}
                    Sie stehen vor strategischen Entscheidungen oder erleben
                    Spannungsfelder, die Sie professionell navigieren möchten.
                  </div>
                </li>
                <li className="flex items-start" data-id="element-328">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-329"></div>
                  <div data-id="element-330">
                    <span className="font-medium" data-id="element-331">
                      Kommunikation im Team oder mit Stakeholdern:
                    </span>{' '}
                    Sie suchen neue Perspektiven und Handlungsoptionen im Umgang
                    mit schwierigen Situationen oder Personen.
                  </div>
                </li>
                <li className="flex items-start" data-id="element-332">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-333"></div>
                  <div data-id="element-334">
                    <span className="font-medium" data-id="element-335">
                      Selbstführung und Resilienz:
                    </span>{' '}
                    Sie möchten Ihre Ressourcen stärken, Stress regulieren und
                    Ihre innere Balance bewahren.
                  </div>
                </li>
                <li className="flex items-start" data-id="element-336">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-337"></div>
                  <div data-id="element-338">
                    <span className="font-medium" data-id="element-339">
                      Change-Prozesse und Transformation begleiten:
                    </span>{' '}
                    Sie führen Veränderungen und möchten Ihre Rolle als
                    Gestalter:in klar und wirksam ausfüllen.
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg mb-12" data-id="element-340">
              <h2 className="text-2xl font-light text-gray-700 mb-6" data-id="element-341">
                Coaching-Formate in meiner Praxis:
              </h2>
              <ul className="space-y-4 text-gray-700" data-id="element-342">
                <li className="flex items-start" data-id="element-343">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-344"></div>
                  <div data-id="element-345">
                    <span className="font-medium" data-id="element-346">Einzelcoaching</span> –
                    persönlich und vertraulich, in meiner Praxis oder online
                  </div>
                </li>
                <li className="flex items-start" data-id="element-347">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-348"></div>
                  <div data-id="element-349">
                    <span className="font-medium" data-id="element-350">Walk & Talk</span> – Coaching
                    in Bewegung, draußen in der Natur, fördert Klarheit und neue
                    Perspektiven
                  </div>
                </li>
                <li className="flex items-start" data-id="element-351">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-352"></div>
                  <div data-id="element-353">
                    <span className="font-medium" data-id="element-354">Online-Coaching</span> –
                    flexibel und ortsunabhängig, mit gleicher Tiefe und
                    Verbindung
                  </div>
                </li>
                <li className="flex items-start" data-id="element-355">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-356"></div>
                  <div data-id="element-357">
                    <span className="font-medium" data-id="element-358">Kurzzeit-Coaching</span> –
                    fokussiert auf konkrete Anliegen oder Entscheidungen
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-pink-50 p-8 rounded-lg mb-8" data-id="element-359">
              <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-360">
                Coaching, das bleibt
              </h2>
              <p className="text-lg text-gray-700" data-id="element-361">
                Coaching ist keine Therapie – aber es kann tiefgreifend
                verändern. Es geht nicht darum, besser zu „funktionieren",
                sondern echte Verbindung zu sich selbst zu entwickeln und daraus
                neue Kraft und Klarheit zu schöpfen.
              </p>
            </div>
            <div className="text-center" data-id="element-362">
              <p className="text-gray-600 mb-4" data-id="element-363">
                Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
                finden Sie unter{' '}
                <a href="/angelika_sturny/info" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-364">
                  Info
                </a>
                .
              </p>
              <p className="text-gray-600" data-id="element-365">
                Appointments are also possible in English. Please contact me via{' '}
                <a href="mailto:praxis@angelikasturny.com" className="text-[#cda8be] hover:text-[#b88fa8] hover:font-semibold transition-colors" data-id="element-366">
                  email
                </a>{' '}
                for sessions in English!
              </p>
            </div>
          </div>
        </div>
      </section>
      <AngelikaSturnFooter data-id="element-367" />
    </div>;
}